// Rate cards bundled with pricing-core (Quote Brain DESIGN.md 4.2).
// ----------------------------------------------------------------------------
// A rate card is a business's own authority: its rate rows and the pricing
// methodology its quotes follow. Pricing takes the card as an argument, and
// this loader supplies a bundled card by its authority id. Which business
// uses which card is the caller's per-business configuration, so one
// business's card never reaches another's run.
//
// RJ Bird's card (Francis's rate-card authority) is the only bundled card.
// scripts/sync-francis-rate-card.mjs writes it.
// ============================================================================

import rjBirdRateCardAuthority from './rate-cards/rj-bird-rate-card-authority.json' with { type: 'json' };

/** RJ Bird's rate card authority id ('francis-skill-rate-card-v1'). */
export const RJ_BIRD_RATE_CARD_ID = rjBirdRateCardAuthority.authority_id;

const BUNDLED_RATE_CARDS = new Map([[RJ_BIRD_RATE_CARD_ID, rjBirdRateCardAuthority]]);

/**
 * The bundled rate card with this authority id, or null. The record is shared,
 * not copied: callers must not change it.
 * @param {string} authorityId
 */
export function loadRateCard(authorityId) {
    return BUNDLED_RATE_CARDS.get(String(authorityId || '')) || null;
}
